import React, { useState } from "react";
import { toast } from "sonner";
import { UploadSimple, Spinner } from "@phosphor-icons/react";
import { api, resolveImg } from "../lib/api";

export const ImageField = ({ label, value, onChange }) => {
  const [uploading, setUploading] = useState(false);

  const handleFile = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    setUploading(true);
    const fd = new FormData();
    fd.append("file", file);
    try {
      const { data } = await api.post("/upload", fd, { headers: { "Content-Type": "multipart/form-data" } });
      onChange(data.url);
      toast.success("Image uploaded");
    } catch (err) {
      toast.error("Upload failed. Images only (jpg/png/webp).");
    } finally {
      setUploading(false);
    }
  };

  return (
    <div>
      <label className="text-sm font-medium text-navy mb-2 block">{label}</label>
      <div className="flex items-center gap-4">
        {value ? (
          <img src={resolveImg(value)} alt={label} className="h-20 w-28 object-cover border border-navy/10" />
        ) : (
          <div className="h-20 w-28 bg-navy/5 border border-navy/10 grid place-items-center text-navy/30 text-xs">No image</div>
        )}
        <label className="cursor-pointer inline-flex items-center gap-2 border border-navy/20 px-4 py-2.5 rounded-sm text-sm font-medium text-navy hover:border-gold transition-colors">
          {uploading ? <Spinner size={18} className="animate-spin" /> : <UploadSimple size={18} />}
          {uploading ? "Uploading…" : "Replace image"}
          <input type="file" accept="image/*" className="hidden" onChange={handleFile} disabled={uploading} />
        </label>
      </div>
    </div>
  );
};
